import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';

(function() {
    'use strict';

    var kissOrderGrid = {
        templateUrl: require('./grid.html'),
        bindings: {
            gridParams: '=', // Critères de recherche de la grille
            data: '<', // Données à afficher dans la grille,
            searchFunction: '&', // Fonction de recherche
            searchPromise: '<' // La promesse de la recherche.
        },
        controller: KissOrderGridController
    };

    KissOrderGridController.$inject = ['$scope', 'ORDERS', 'uiGridConstants'];

    function KissOrderGridController($scope, ORDERS, uiGridConstants) {
        var vm = this;
        vm.getGridHeight = getGridHeight;

        vm.gridOptions = {
            columnDefs: ORDERS.columnDefs,
            exporterOlderExcelCompatibility: true,
            useExternalPagination: true,
            useExternalSorting: true,
            onRegisterApi: onRegisterApi,
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
            paginationPageSizes: vm.paginationPageSizes,
            paginationPageSize: vm.paginationPageSize
        };

        vm.$onChanges = function(changesObj) {
            if (changesObj.data) {
                vm.gridOptions.data = changesObj.data.currentValue.content;
                vm.gridOptions.totalItems = changesObj.data.currentValue.totalElements;
            }
        };

        // Grille
        function onRegisterApi(gridApi) {
            vm.gridApi = gridApi;

            // Sorting & pagination
            gridApi.core.on.sortChanged($scope, sortChanged);
            gridApi.pagination.on.paginationChanged($scope, paginationChanged);
        }

        function sortChanged(grid, sortColumns) {
            sortColumns = _.map(sortColumns, convertSort);
            vm.gridParams.sorts = sortColumns;
            vm.searchFunction();
        }

        function convertSort(col) {
            var columnField = _.find(ORDERS.columnFieldMap, { field: col.field });
            if (col && col.sort) {
                return {
                    direction: angular.uppercase(col.sort.direction),
                    property: columnField ? columnField.property : col.field,
                    priority: col.sort.priority
                };
            }
            return {};
        }

        function paginationChanged(page, size) {
            vm.gridParams.paginationPageSize = size;
            vm.gridParams.page = page - 1;
            vm.searchFunction();
        }

        function getGridHeight() {
            return gridHeight(vm.gridApi);
        }
    }

    angular.module('app.kissorder').component('kissOrderGrid', kissOrderGrid);
})();
